// extracted by mini-css-extract-plugin
export default {"wrapper":"GroupsContainer_wrapper__5QOXn"};